import moment from "moment";
import { isDate, isNumber, isString } from "lodash";
import { isEmptyVal } from "@/utils/index";

export const DATE_LONG_FORMAT = "MMM D, YYYY";

export const dateTimeFormat = (value, formatDateTime = DATE_LONG_FORMAT) => {
  if (isEmptyVal(value)) {
    return "";
  } else if (
    (isDate(value) || isNumber(value) || isString(value)) &&
    moment(value).isValid()
  ) {
    // This method directly parses the provided date string into UTC time and creates a corresponding Moment object.
    // This means that the Moment object will always maintain the UTC time zone in subsequent operations,
    // no matter what operations are performed afterwards.
    return moment.utc(value).format(formatDateTime);
  } else if (moment.isMoment(value)) {
    return value.utc().format(formatDateTime);
  }
  return value;
};